import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[2],
  },

  label: {
    color: colors.textSecondary,
    fontWeight: '500',
  },

  currentLabel: {
    flexShrink: 1,
    color: colors.textBrand,
    fontWeight: '500',
  },
}));
